import React from "react";

import { Box, Typography } from "@mui/material";
import { withStyles } from "tss-react/mui";

import NoCommentsIcon from "@/components/Icons/NoCommentsIcon";

const Container = withStyles(Box, {
  root: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    minHeight: "45vh",
  },
});

const StyledNoCommentsIcon = withStyles(NoCommentsIcon, {
  root: {
    height: 34.45,
    width: 40,
  },
});

const NoExerciseCommentTitle = withStyles(Typography, {
  root: {
    color: "#AAB0BB",
    fontSize: "14px",
    fontWeight: 600,
  },
});

const ExerciseCommentEmptyView: React.FC = () => {
  return (
    <Container>
      <StyledNoCommentsIcon />
      <Box height={11} />
      <NoExerciseCommentTitle>No comment</NoExerciseCommentTitle>
    </Container>
  );
};

export default ExerciseCommentEmptyView;
